<template>
  <div class="appBody bg-grey-light">

<!--    <div class="shareImg position-fixed cursor-pointer">-->
<!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
<!--    </div>-->
    <little-header></little-header>
    <div v-if="orderObj">
      <div class="order-top px-3 d-flex flex-column justify-content-center">
        <p class="order-status d-flex mb-0 ">
          <span class="d-block">{{orderErrorStatus?orderErrorStatus:orderType?orderStatus[orderType]:''}}</span>
          <span class="d-block order-dian ml-2 font-weight-bold" v-if="isToPay">···</span>
        </p>
        <p class="mb-0 mt-2 text-white text-truncate font-12"
           v-if="orderErrorStatus === '' && isToPay && leftTime>0">
          订单超过有限期会自动取消，请在{{leftTime|getTimeLeftStrOrder}}内完成支付
        </p>
        <p class="mb-0 mt-2 text-white text-truncate font-12"
           v-if="orderErrorStatus === '' && isToPay && leftTime <= 0">
          该订单超时未完成支付，已由系统自动取消
        </p>
      </div>
      <div class="bg-white">
        <van-row class="merchant flex-nowrap align-items-center" type="flex">
          <img class="merchant-img" src="/static/img/pro/yudi.png">
          <van-col class=" font-13 line-16 text-truncate">{{orderObj.merchantName}}</van-col>
        </van-row>
      </div>
      <!-- 预付项目 -->
      <div class="bg-white" v-if="orderObj.orderFrom === 'project' && orderObj.presale">
        <van-row class="detail-step px-3 d-flex align-items-center bg-white" type="flex">
          <van-col><span class="d-block bg-primary detail-tiao mr-12"></span></van-col>
          <van-col><span
            class="d-block text-primary font-14 line-14 font-weight-600">阶段1：{{ oneFinished ? '已完成' : '待付款' }}</span>
          </van-col>
        </van-row>
        <div class="bg-white card-div">
          <div class="detail-card position-relative">
            <van-row class="detail-step1-card" justify="space-between" type="flex">
              <van-col class="font-13 line-15 text-black">项目预付款</van-col>
              <van-col class="text-primary font-15 line-13">
                <span
                  class="color-66 font-11 mr-1p">¥ </span><span>{{orderObj.presaleAmount|getMoney|getMoney1}}</span><span
                class="font-11">{{orderObj.presaleAmount|getMoney|getMoney2}}</span>
              </van-col>
            </van-row>
            <img alt="" class="dd-img dd-left" src="/static/img/pro/dd-left.png">
            <img alt="" class="dd-img dd-right" src="/static/img/pro/dd-left.png">
          </div>
        </div>
        <van-row class="detail-step px-3 d-flex align-items-center bg-white" type="flex">
          <van-col><span class="d-block bg-primary detail-tiao mr-12"></span></van-col>
          <van-col><span
            class="d-block text-primary font-14 line-14 font-weight-600">阶段2：{{ !oneFinished ? '定价中' : orderStatus[orderType] }}</span>
          </van-col>
        </van-row>
        <div class="bg-white card-div card-div-other">
          <div class="detail-card detail-card-other  position-relative">
            <img alt="" class="dd-img dd-left" src="/static/img/pro/dd-left.png">
            <img alt="" class="dd-img dd-right" src="/static/img/pro/dd-left.png">
            <van-row class="detail-card-header" justify="space-between" type="flex">
              <van-col class="font-13 line-14 text-black">项目尾款</van-col>
              <div>
                <order-jia-hui-fu :data-model="orderObj" :expect="true" :expectMoney="expectMoney"
                                  :status="orderType"></order-jia-hui-fu>
              </div>
            </van-row>
            <div v-if="orderObj && orderObj.items && orderObj.items.length>0">
              <van-card :key="item.id" :price="item.originUnitPrice|getMoney"
                        :thumb="uploadresUrl+item.goodsImage"
                        :title="item.goodsName"
                        class="detail-pro-card"
                        v-for="item in orderObj.items"
              />
            </div>

          </div>
        </div>
      </div>
      <!-- 非预付项目 & 课程 -->
      <div class="bg-white" v-else>
        <van-row class="detail-step px-3 d-flex align-items-center bg-white" type="flex">
          <van-col><span class="d-block bg-primary detail-tiao mr-12"></span></van-col>
          <van-col><span class="d-block text-primary font-14 line-14 font-weight-600">价格详情</span></van-col>
        </van-row>
        <div class="bg-white card-div card-div-other ">

          <div class="detail-card pb-0 detail-card-other  position-relative  d-flex flex-column-reverse">
            <img alt="" class="dd-img dd-left" src="/static/img/pro/dd-left.png">
            <img alt="" class="dd-img dd-right" src="/static/img/pro/dd-left.png">
            <van-row class="detail-card-header detail-card-header1 flex-row-reverse" justify="space-between"
                     type="flex">
              <order-jia-hui-fu :data-model="orderObj" :status="orderType"></order-jia-hui-fu>
            </van-row>
            <div v-if="orderObj && orderObj.orderFrom === 'project' && orderObj.items && orderObj.items.length>0">
              <van-card :key="item.id" :price="item.originUnitPrice|getMoney"
                        :thumb="uploadresUrl+item.goodsImage"
                        :title="item.goodsName"
                        class="detail-pro-card"
                        v-for="item in orderObj.items"
              >
                <template #num>
                  <div v-if="item.status==='refund'">{{ orderStatus[item.status] }}</div>
                </template>
              </van-card>
            </div>
            <div v-if="orderObj.orderFrom === 'course'">
              <van-card
                :price="itemModel.originUnitPrice|getMoney"
                :thumb="uploadresUrl+itemModel.goodsImage"
                :title="itemModel.goodsName"
                class="detail-pro-card"
              />
            </div>

          </div>
        </div>
      </div>

      <div class="detail-info-div bg-white  pb-100">
        <p class="mb-0 font-weight-600 color-0d font-14">订单信息</p>
        <van-row class="flex-nowrap font-13 line-13 detail-num color-33" type="flex">
          <van-col>订单编号：</van-col>
          <van-col>{{orderObj.id}}</van-col>
          <van-col class="text-primary ml-3 cursor-pointer" @click="copyFun">复制</van-col>
        </van-row>
        <van-row class="flex-nowrap font-13 line-13 order-jie" type="flex">
          <van-col>创建时间：</van-col>
          <van-col>{{orderObj.createdTime | dateFormat}}</van-col>
        </van-row>
        <div v-if="orderObj.steps && orderObj.steps.length>0" :class="orderObj.steps.length>1?'mt-3':''">
          <div v-for="item in orderObj.steps" :key="item.id">
            <van-row v-if="orderObj.steps.length>1" class="flex-nowrap font-13 line-13 order-jie pt-1" type="flex">
              <van-col class="font-14 line-15 text-primary order-jie">阶段{{item.step+1}}</van-col>
            </van-row>
            <van-row class="flex-nowrap font-13 line-13 order-jie" type="flex">
              <van-col>订单金额：</van-col>
              <van-col>¥ {{item.amount|getMoney}}</van-col>
            </van-row>
            <van-row class="flex-nowrap font-13 line-13 order-jie" type="flex">
              <van-col>支付状态：</van-col>
              <van-col>{{orderStatus[item.status]?orderStatus[item.status]:orderStatus['unknown']}}</van-col>
            </van-row>

            <van-row v-if="channelArr[item.id]" class="flex-nowrap font-13 line-13 order-jie" type="flex">
              <van-col>支付方式：</van-col>
              <van-col>{{channelText[channelArr[item.id].channel?channelArr[item.id].channel:'balance']}}</van-col>
            </van-row>
            <van-row v-if="channelArr[item.id]" class="flex-nowrap font-13 line-13 order-jie" type="flex">
              <van-col>支付时间：</van-col>
              <van-col v-if="channelArr[item.id].finishedTime">
               {{channelArr[item.id].finishedTime | dateFormat}}
              </van-col>
              <van-col v-else>
               {{channelArr[item.id].updatedTime | dateFormat}}
              </van-col>

            </van-row>
            <span class="d-block mx-3 pt-20 border-bottom-grey05"></span>
          </div>

        </div>
      </div>

      <div class="detail-tool border-top bg-white d-flex justify-content-around align-items-center"
           v-if="orderErrorStatus === '' && orderType=== 'prepaying' || orderType=== 'topay'  || orderType === 'pricing' ">
        <van-button class="color-66" hairline plain @click="cancelOrder"
                    round v-if="orderType === 'prepaying' || orderType=== 'topay'">取消订单
        </van-button>
        <van-button hairline round
                    type="info" v-if="orderType === 'prepaying'">预付
        </van-button>
        <van-button hairline round @click="pay"
                    type="info" v-if="orderType === 'topay'">支付
        </van-button>
        <van-button hairline plain round
                    type="info" v-if="orderType === 'pricing'">待付
        </van-button>
      </div>
    </div>
    <!--    <little-footer></little-footer>-->
  </div>
</template>

<script>
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";
  import OrderJiaHuiFu from "./component/orderJiaHuiFu";
  import Vue from 'vue';
  import {Dialog, Icon} from 'vant';
  import {SwipeCell} from 'vant';
  import {Button} from 'vant';
  import {Col, Row} from 'vant';
  import {Card} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Card);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Button);
  Vue.use(SwipeCell);
  Vue.use(Icon);
  export default {
    name: "detailOrder",
    data() {
      return {
        shareObj: {},
        orderObj: {},
        itemModel: {},
        successChannelObj: {},
        orderId: '',
        oneFinished: false,
        orderType: '',
        orderErrorStatus: '',
        traId: '',
        leftTime: 0,
        //  leftTimeStr: 0,
        isToPay: false,
        btns: [],
        channelArr: {},
        canceling: false,
      }
    },
    components: {
      littleFooter,
      LittleHeader,
      OrderJiaHuiFu
    },
    created() {
      this.traId = this.$route.query['traId'];
      if(this.traId) {
        Dialog.confirm({
          title: '信息',
          message: '支付成功，请问您接下来打算？',
          confirmButtonText: '开始学习',
          cancelButtonText: '查看订单',
        }).then(() => {
          // 开始学习
          this.$router.push('/'+this.orderObj.orderFrom+'/' + this.orderObj.merchantId);
        });
      }
    },
    mounted() {
      this.orderId = this.$route.params['id'];

      this.loadData();
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        orderStatus: state => state.orderStatus,
        channelText: state => state.channelText,
      }),
    },
    watch: {
      isToPay: function (val) {
        if (val) {
          this.leftTime = this.orderObj.expiredCountdown;
          setInterval(() => {
            if (this.leftTime > 0) {
              this.leftTime -= 1000;
            } else {
              this.orderObj.paying = true;
              this.orderObj.expired = true;
              this.getOrderStatus();
              this.getOrderStatusExpired();
              clearInterval();
            }

          }, 1000);
        }
      }
    },
    methods: {
      pay() {
        this.$router.push('/pay/'+this.orderId);
      },
      loadData() {
        this.$store.dispatch('getOrderById', {id: this.orderId}).then((res) => {
          if (res) {
            this.orderObj = res;
            if (this.orderObj.items && this.orderObj.items.length === 1) {
              this.itemModel = this.orderObj.items[0];
            }
            if (this.orderObj.steps && this.orderObj.steps[1] && this.orderObj.steps[1].amount) {
              this.expectMoney = this.orderObj.steps[1].amount;
            } else {
              this.expectMoney = 0;
            }
            if (this.orderObj.presale && this.orderObj.presaleStatus === 'success') {
              this.oneFinished = true;
            } else {
              this.oneFinished = false;
            }
            this.getOrderStatus();
            this.getOrderStatusExpired();
            console.log(this.orderType);
            if (this.orderErrorStatus === '' && ['prepaying', 'topay'].indexOf(this.orderType) >= 0) {
              this.isToPay = true;
            } else {
              this.isToPay = false;
            }
            ///循环steps
            if (this.orderObj.steps && this.orderObj.steps.length > 0) {
              for (let item of this.orderObj.steps) {
                this.channelArr[item.id] = '';
                if (item.status === 'success' && item.completedTransactions && item.completedTransactions.length > 0) {
                  for (let itm of item.completedTransactions) {
                    if (itm.status === 'success') {
                      this.channelArr[item.id] = itm;
                      break;
                    }
                  }
                }
              }
            }
          }
        })
      },
      copyFun() {
        let orderId = this.orderId;
        let oInput = document.createElement("input");
        oInput.value = orderId;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.className = "oInput";
        oInput.style.display = "none";
        this.$toast({
          message: "复制成功!",
          type: 'success'
        })
      },
      getOrderStatus() {
        /// 待预付
        if ((this.orderObj.presale) && this.orderObj.presaleStatus === 'unpaid') {
          this.orderType = 'prepaying';
        }/// 已预付 - 定价中
        else if ((this.orderObj.presale) &&
          this.orderObj.presaleStatus === 'success' &&
          this.orderObj.status === 'pricing') {
          this.orderType = 'pricing';
        }

        /// 预付项目 待支付
        else if ((this.orderObj.presale) &&
          this.orderObj.presaleStatus === 'success' &&
          this.orderObj.status === 'unpaid') {
          this.orderType = 'topay';
        }/// 非预售 待支付
        else if (!(this.orderObj.presale) && this.orderObj.status === 'unpaid') {
          this.orderType = 'topay';
        } else {
          /// 其它的返回status
          this.orderType = this.orderObj.status;
        }

      },
      /// 根据订单属性，判断订单状态
      /// 这个只判断过期，有问题，有异常，已失败，已取消
      /// 显示的价格按照下一个方法判断
      getOrderStatusExpired() {
        if ((this.orderObj.paying) && (this.orderObj.expired)) {
          this.orderErrorStatus = this.orderStatus['expired'];
        } else if (this.orderObj.status === 'unknown' ||
          this.orderObj.status === 'error' ||
          this.orderObj.status === 'failed' ||
          this.orderObj.status === 'canceled') {
          this.orderErrorStatus = this.orderStatus[this.orderObj.status];
        } else {
          this.orderErrorStatus = '';
        }
      },
      cancelOrder() {
        if (!this.canceling) {
          this.canceling = true;
          this.$store.dispatch('cancelOrder', {id: this.orderObj.id, tradeFrom: 'H5'}).then((res) => {
            setTimeout(() => {
              this.$toast('操作成功！');
            }, 1000);
            this.loadData();
          }).catch((error) => {
            this.$toast('取消订单操作失败！');
          })
        } else {
          return false;
        }
      },
      submit() {
        if (!this.canceling) {
          this.canceling = true;
        } else {
          return false;
        }
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //   this.shareObj = this.orderObj;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'order';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },
    }
  }
</script>
<style scoped>
  .pb-100 {
    padding-bottom: 10rem !important;
  }

  .pt-20 {
    padding-top: 1.25rem;
  }

  .order-top {
    height: 4.6875rem;
    background: url("/static/img/pro/ddtop-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .order-status {
    color: #ffffff;
    font-size: 1.375rem;
    line-height: 1.375rem;
  }

  .order-dian {
    font-size: 2.5rem;
  }

  .merchant {
    padding: 1.5rem 0 .9375rem;
    margin: 0 1rem 0;
    background-color: white;
    border-bottom: 1px solid #9E9E9E40;
  }

  .merchant-img {
    flex: 0 0 0.8125rem;
    height: .8125rem;
    margin-right: .375rem;
  }

  .detail-step {
    padding-top: 1.125rem;
    padding-bottom: .9375rem;
  }

  .detail-tiao {
    width: .25rem;
    height: 1rem;
    border-radius: .1875rem;
  }

  .card-div {
    padding: 0 .75rem .9375rem;
  }

  .card-div-other {
    padding-bottom: 2rem;
  }

  .detail-card {
    border-radius: .5rem;
    box-shadow: 0 0 .375rem .25rem #9E9E9E40;
    padding-bottom: 1.25rem;
  }

  .detail-card-header {
    border-bottom: 1px solid #9E9E9E40;
    padding: 1.125rem 1.25rem 0.75rem 1.25rem;
  }

  .detail-card-header1 {
    border-top: 1px solid #9E9E9E40;
    margin-top: 1.25rem;
  }

  .dd-img {
    position: absolute;
    top: 50%;
    bottom: 0;
    margin-top: -0.325rem;
    text-align: center;
    width: .625rem;
    color: #9E9E9E40;
  }

  .dd-left {
    left: -1px;
  }

  .dd-right {
    display: block;
    right: -1px;
    transform: rotate(180deg);
    -ms-transform: rotate(180deg); /* IE 9 */
    -moz-transform: rotate(180deg); /* Firefox */
    -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
    -o-transform: rotate(180deg);
  }

  .detail-pro-card {
    padding: 0 0 1rem !important;
    margin: 1.125rem 1.25rem 0 1.25rem;
    border-bottom: 1px dashed #9E9E9E40;
  }

  .detail-card-other .detail-pro-card:last-child {
    border-bottom: none !important;
    padding-bottom: 0 !important;
  }

  .detail-step1-card {
    padding: 1.125rem 1rem 0;
  }

  .detail-info-div {
    margin-top: 0.875rem;
    padding: 1rem;
  }

  .detail-num {
    margin-top: 1.1875rem;
  }

  .detail-tool {
    max-width: 640px;
    padding: .75rem 0;
    margin: 0 auto;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 888;
  }

  .detail-tool button {
    width: 7.5rem;
    height: 2.125rem !important;
    font-size: .875rem;
    padding: 0 !important;
  }

  .detail-tool button.van-button--default {
    color: #9E9E9E;
    border: 1px solid #9E9E9E;
  }

  .detail-tool button.van-button--plain.van-button--info {
    color: #2474FF;
    border: 1px solid #2474FF;
  }

  .order-jie {
    margin-top: .5625rem;
    color: #333333;
  }
</style>
